import React from 'react';
import { Bar, BarChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';

interface DailyLiters {
  date: string;
  liters: number;
  minutes: number;
}

interface Props {
  dailyLiters: DailyLiters[];
}

const formatDay = (isoDate: string) => {
  const [, month, day] = isoDate.split('-');
  return `${day}/${month}`;
};

// El eje muestra litros (lo que más importa de un vistazo) — los minutos
// regados ese día quedan en el tooltip, así el gráfico no necesita dos ejes.
const ChartTooltip: React.FC<{ active?: boolean; payload?: { payload: DailyLiters }[]; label?: string }> = ({
  active,
  payload,
  label,
}) => {
  if (!active || !payload || payload.length === 0) return null;
  const { liters, minutes } = payload[0].payload;
  return (
    <div
      style={{
        background: 'var(--domiot-surface)',
        border: '1px solid var(--domiot-border)',
        borderRadius: 10,
        fontSize: 12,
        padding: '8px 12px',
      }}
    >
      <p style={{ margin: '0 0 4px', fontWeight: 700 }}>{formatDay(String(label))}</p>
      <p style={{ margin: 0, color: 'var(--domiot-accent)', fontWeight: 600 }}>{liters} L</p>
      <p style={{ margin: '2px 0 0', color: 'var(--domiot-text-muted)' }}>{minutes} min regados</p>
    </div>
  );
};

const IrrigationHistoryChart: React.FC<Props> = ({ dailyLiters }) => {
  if (dailyLiters.length === 0) {
    return (
      <p style={{ color: 'var(--domiot-text-muted)', fontSize: 13 }}>
        Todavía no hay riegos completados para graficar.
      </p>
    );
  }

  return (
    <ResponsiveContainer width="100%" height={180}>
      <BarChart data={dailyLiters} margin={{ top: 8, right: 12, bottom: 0, left: 4 }} barCategoryGap={4}>
        <CartesianGrid vertical={false} stroke="var(--domiot-border)" strokeDasharray="3 3" />
        <XAxis
          dataKey="date"
          tickFormatter={formatDay}
          tick={{ fontSize: 11, fill: 'var(--domiot-text-muted)' }}
          axisLine={{ stroke: 'var(--domiot-border)' }}
          tickLine={false}
        />
        <YAxis
          tick={{ fontSize: 11, fill: 'var(--domiot-text-muted)' }}
          axisLine={false}
          tickLine={false}
          width={46}
          tickFormatter={(v: number) => `${Math.round(v)}L`}
        />
        <Tooltip content={<ChartTooltip />} cursor={{ fill: 'var(--domiot-surface-alt)' }} />
        <Bar dataKey="liters" fill="var(--domiot-accent)" radius={[4, 4, 0, 0]} maxBarSize={28} />
      </BarChart>
    </ResponsiveContainer>
  );
};

export default IrrigationHistoryChart;
